import http from './httpRequest.js'

/**
 * 一对一通话信令接口
 * 全部为 POST + query 参数，响应由 http 拦截器解包为 data
 */
class LivekitPrivateApi { }

LivekitPrivateApi.prototype.call = function (targetId, type) {
	return http({
		url: `/livekit/p2p/call?targetId=${targetId}&type=${type}`,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.accept = function (targetId, roomTag, messageId) {
	let url = `/livekit/p2p/accept?targetId=${targetId}&roomTag=${encodeURIComponent(roomTag)}`
	if (messageId) {
		url += `&messageId=${messageId}`
	}
	return http({
		url,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.ring = function (targetId) {
	return http({
		url: `/livekit/p2p/ring?targetId=${targetId}`,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.reject = function (targetId, messageId) {
	let url = `/livekit/p2p/reject?targetId=${targetId}`
	if (messageId) {
		url += `&messageId=${messageId}`
	}
	return http({
		url,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.busy = function (targetId, messageId) {
	let url = `/livekit/p2p/busy?targetId=${targetId}`
	if (messageId) {
		url += `&messageId=${messageId}`
	}
	return http({
		url,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.cancel = function (targetId) {
	return http({
		url: `/livekit/p2p/cancel?targetId=${targetId}`,
		method: 'post'
	})
}

LivekitPrivateApi.prototype.finish = function (targetId, roomTag, messageId) {
	let url = `/livekit/p2p/finish?targetId=${targetId}&roomTag=${encodeURIComponent(roomTag || '')}`
	if (messageId) {
		url += `&messageId=${messageId}`
	}
	return http({
		url,
		method: 'post'
	})
}

/**
 * 拉取离线通话事件
 * @param {number} minEventId 上次已处理的最大事件 id，首次传 0
 */
LivekitPrivateApi.prototype.offlineMessage = function (minEventId) {
	return http({
		url: `/livekit/p2p/offlineMessage?minEventId=${minEventId || 0}`,
		method: 'get'
	})
}

export default LivekitPrivateApi
